<template>
  <div class="relative"></div>
  <div class="h-80 bg-bgheader absolute w-full"></div>
  <div class="absolute w-full">
    <div class="flex flex-col justify-center">
      <h1 class="text-right text-lg font-bold mb-3 pt-12 mr-2 text-white">
        گزارش خرید مشتری
      </h1>
    </div>
    <div v-if="orders.length != 0" class="mb-24 mt-6">
      <div
        class="block bg-white rounded-2xl px-4 py-6 border text-cyan-900 text-sm mt-2 mx-4 shadow-lg"
        v-for="order in orders"
        :key="order.id"
        @click="selectOrder(order.id)"
      >
        <div class="grid grid-cols-1 gap-y-4">
          <div>
            <font-awesome-icon icon="circle-user" class="fa-xl text-bgfont" />
            <span class="font-bold mr-1"> نام : </span>
            <span> {{ order.customerName }}</span>
          </div>
          <div>
            <font-awesome-icon icon="calendar-days" class="fa-xl text-bgfont" />
            <span class="font-bold mr-1"> تاریخ : </span>
            <span> {{ order.pBasketDate }}</span>
          </div>
          <div>
            <font-awesome-icon icon="hashtag" class="fa-xl text-bgfont" />
            <span class="font-bold mr-1"> شماره مشتری : </span>
            <span> {{ order.customerId }}</span>
          </div>
          <div>
            <font-awesome-icon icon="arrows-rotate" class="fa-xl text-bgfont" />
            <span class="font-bold mr-1"> وضعیت مشتری : </span>
            <span> {{ order.basketStatus_Name }}</span>
          </div>
          <div>
            <font-awesome-icon
              icon="money-check-dollar"
              class="fa-xl text-bgfont"
            />
            <span class="font-bold mr-1"> مبلغ نهایی : </span>
            <span>
              {{ $helper.priceFormatter(order.totalPrice_AfterTax) }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="block bg-white rounded-2xl px-4 py-11 border text-cyan-900 text-center text-lg mt-4 mx-4 shadow-lg h-36"
      v-else
    >
      <span class="text-red-800 font-bold">داده ای برای نمایش وجود ندارد</span>
    </div>
    <div v-if="orders.length > 5">
      <v-pagination
        v-model="pagination.PageNumber"
        :pages="pagination.TotalPages"
        :range-size="1"
        active-color=""
        @update:modelValue="getOrders"
      />
    </div>
  </div>
</template>
<script>
import VPagination from "@hennge/vue3-pagination";
import "../../assets/css/pagination.css";
import { getOrders, getProducts } from "@/API/API";
export default {
  name: "ReportSales",
  components: { VPagination },
  data() {
    return {
      requests: [],
      custid: this.$route.params.customerId,
      pagination: {},
      orders: [],
      products: [],
      result: [],
      anbarId: "",
    };
  },
  async created() {
    this.getOrders(1);
  },
  methods: {
    async getOrders(pageNumber) {
      this.requests = (await getOrders(pageNumber, this.custid)).data.result;
      this.orders = [];
      this.orders = this.requests.orders;
      this.pagination = {};
      this.pagination = this.requests.pagination;
    },
    async updateCart(id) {
      this.result = (await getProducts(id)).data.result;
      this.products = this.result.orderdetails;
      this.anbarId = this.result.order.anbarId;
      console.log(this.result);

      this.$store.dispatch("selectedCustomer", this.custid);
      this.$store.dispatch("selectedAnbar", this.result.order.anbarId);
      this.$store.dispatch("orderId", id);

      this.$router.push({
        name: "CartPage",
        query: {
          updateOrder: true,
        },
      });

      this.products.forEach((item) => {
        this.$store.dispatch("editProduct", item).catch((err) => {
          this.$swal({
            icon: "error",
            title: "خطا",
            text: err,
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });
        });
      });
    },
    selectOrder(id) {
      this.$router.push(`/repeatfactor/${id}`);
    },
  },
};
</script>
